import React, {useState} from "react";

function VehicleSidebar({offer}) {

    const [showSummary, setShowSummary] = useState(true);

    const vehicle = offer.vehicle;
    const calculation = offer.calculation;
    const isCompany = offer.calculation && offer.calculation.customerType !== "PERSON";

    const calcInstallment = calculation
        ? (calculation.installmentNet || calculation.installmentGross)
        : null;
    const vehicleInstallment = isCompany ? vehicle.installmentNet : vehicle.installmentGross;
    const installment = calcInstallment || vehicleInstallment;
    const catalogPrice = isCompany ? vehicle.basicPriceNet : vehicle.basicPriceGross;
    const ourPrice = isCompany ? vehicle.minimumPriceNet : vehicle.minimumPriceGross;

    const hasDiscount = vehicle.discountVisible && ourPrice && catalogPrice && ourPrice < catalogPrice;
    const discountPercent = hasDiscount
        ? Math.round((1 - ourPrice / catalogPrice) * 100)
        : null;

    const formatPrice = (val) =>
        val != null && val !== "" ? val.toLocaleString("pl-PL", {minimumFractionDigits: 2, maximumFractionDigits: 2}) : "–";

    const ocAcChecked = calculation && calculation.ocAcInsuranceChecked;
    const ocAcData = calculation && calculation.ocAcInsuranceData;
    const ocAcAmount = ocAcData ? (isCompany ? ocAcData.companyInsurance : ocAcData.consumerInsurance) : null;
    const ocAcSuffix = isCompany ? "netto" : "brutto";
    const ocAcPriceText = ocAcChecked
        ? (ocAcAmount != null
            ? Math.round(ocAcAmount).toLocaleString('pl-PL') + " zł " + ocAcSuffix
            : "indywidualna wycena")
        : null;

    const gapChecked = calculation && calculation.gapChecked;
    const gapData = calculation && calculation.gapData;
    const gapSuffix = isCompany ? "netto" : "brutto";
    const gapPriceText = gapChecked
        ? (gapData && gapData.oneTimePremium != null
            ? gapData.oneTimePremium.toLocaleString('pl-PL') + " zł " + gapSuffix
            : "indywidualna wycena")
        : null;

    const drivePlusInstallment = calculation
        ? (isCompany ? calculation.drivePlusInstallmentNet : calculation.drivePlusInstallmentGross)
        : null;
    const drivePlusPriceText = drivePlusInstallment != null
        ? formatPrice(drivePlusInstallment) + " zł/mies."
        : null;

    const isLeasing = calculation && calculation.buyoutValueNet !== undefined;

    const periodLabel = isLeasing ? "Okres leasingu" : "Liczba rat";
    const buyoutValue = calculation
        ? (isCompany ? calculation.buyoutValueNet : calculation.buyoutValueGross)
        : null;

    const summaryRows = [
        {label: periodLabel, value: calculation && calculation.contractLength ? calculation.contractLength + (isLeasing ? " miesięcy" : " rat") : null, hasHelp: false},
        {label: "Opłata wstępna", value: calculation && calculation.initialFeeValueNet != null ? formatPrice(calculation.initialFeeValueNet) + " zł netto" : null, hasHelp: false},
        isLeasing && buyoutValue != null ? {label: "Wykup", value: formatPrice(buyoutValue) + " zł " + (isCompany ? "netto" : "brutto"), hasHelp: false} : null,
        {label: "Rejestracja auta", value: "w cenie", hasHelp: true},
        drivePlusPriceText ? {label: "Pakiet korzyści", value: drivePlusPriceText, hasHelp: false} : null,
        ocAcPriceText ? {label: "Ubezpieczenie OC/AC", value: ocAcPriceText, hasHelp: false} : null,
        gapPriceText ? {label: "GAP", value: gapPriceText, hasHelp: false} : null,
    ].filter(Boolean);

    return (
        <div className="cr-sidebar-wrap">
            <div className="config-card-header">
                <div className="config-card-header-inner">
                    <p className="config-card-title">Wybrane auto</p>
                </div>
            </div>

            <div className="cr-sidebar-vehicle">
                <div className="cr-vehicle-row">
                    {vehicle.imageUrl && (
                        <img
                            src={vehicle.imageUrl}
                            alt={vehicle.brandName + " " + vehicle.modelName}
                            className="cr-vehicle-img"
                        />
                    )}
                    <div>
                        <p className="cr-vehicle-name">
                            {vehicle.brandName} {vehicle.versionName}
                        </p>
                    </div>
                </div>

                <div className="cr-vehicle-specs">
                    {vehicle.segment && (
                        <div className="cr-vehicle-spec">
                            <span>{vehicle.segment}</span>
                        </div>
                    )}
                    {vehicle.gearboxType && (
                        <div className="cr-vehicle-spec">
                            <span>{vehicle.gearboxType}</span>
                        </div>
                    )}
                    {vehicle.engineCapacity && (
                        <div className="cr-vehicle-spec">
                            <span>{vehicle.engineCapacity} cm³ {vehicle.enginePowerHP && "(" + vehicle.enginePowerHP + " KM)"}</span>
                        </div>
                    )}
                    {vehicle.fuelType && (
                        <div className="cr-vehicle-spec">
                            <span>{vehicle.fuelType}</span>
                        </div>
                    )}
                </div>
            </div>

            {(catalogPrice || ourPrice) && (
                <div className="cr-sidebar-price">
                    {catalogPrice && (
                        <div className="cr-price-row">
                            <span>Cena katalogowa</span>
                            <strong>{formatPrice(catalogPrice)} netto</strong>
                        </div>
                    )}
                    {ourPrice && (
                        <div className="cr-price-row">
                            <span>Nasza cena</span>
                            <span className="cr-price-our-value">{formatPrice(ourPrice)} netto</span>
                        </div>
                    )}
                    {hasDiscount && (
                        <span className="cr-price-badge">RABAT -{discountPercent}%</span>
                    )}
                </div>
            )}

            <div className="cr-sidebar-summary">
                <div className="cr-summary-header">
                    <p className="cr-summary-title">Podsumowanie</p>
                    <button type="button" className="cr-summary-toggle" onClick={() => setShowSummary(s => !s)}>
                        {showSummary ? "zwiń składowe" : "rozwiń składowe"}
                        <span style={{fontSize: 10}}>{showSummary ? "▲" : "▼"}</span>
                    </button>
                </div>

                {showSummary && summaryRows.map((row, i) => (
                    <div key={i} className="cr-summary-row">
                        <span className="cr-summary-row-label">
                            {row.label}
                            {row.hasHelp && <span className="cr-help-icon">?</span>}
                        </span>
                        <span className="cr-summary-row-value">{row.value}</span>
                    </div>
                ))}

                {installment && (
                    <div className="cr-rata-box">
                        <span className="cr-rata-label">Rata razem</span>
                        <div className="cr-rata-value">
                            <span className="cr-rata-amount">{Math.round(installment)}</span>
                            <span className="cr-rata-currency">zł</span>
                            <span className="cr-rata-unit">netto / miesiąc</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default VehicleSidebar;
